module.exports = __webpack_public_path__ + "img/competitiveness-bg.587d3dc7.png";